<template>
  <div class="d-flex align-center gap-1">
    <v-icon v-if="isValid" icon="check" size="large" color="success"></v-icon>
    <v-icon
      v-else-if="isWarning"
      icon="alert"
      size="large"
      color="warning"
    ></v-icon>
    <v-icon v-else icon="close" size="large" color="error"></v-icon>

    <template v-if="dense">{{ asnMessageDense }}</template>
    <template v-else>{{ installCodeRow.getAsnMessage() }}</template>
  </div>
</template>

<script lang="ts">
  import { PropType, defineComponent } from "vue"
  import {
    EAsnStatus,
    EAsnStatusType,
    IInstallCode,
  } from "@/models/installCode/installCode.types"

  export default defineComponent({
    props: {
      installCodeRow: {
        type: Object as PropType<IInstallCode>,
        default: () => ({}),
        required: false,
      },
      dense: {
        type: Boolean,
        default: false,
        required: false,
      },
    },
    computed: {
      isValid() {
        return this.installCodeRow.getAsnStatus() === EAsnStatus.VALID
      },
      isWarning() {
        return (
          [EAsnStatus.EXPIRES_SOON, EAsnStatus.MISSING_DATE] as EAsnStatusType[]
        ).includes(this.installCodeRow.getAsnStatus())
      },
      asnMessageDense() {
        switch (this.installCodeRow.getAsnStatus()) {
          case EAsnStatus.UNOBTAINABLE:
            return "Unobtainable"
          case EAsnStatus.VALID:
            return "Uploaded"
          case EAsnStatus.EXPIRED:
          case EAsnStatus.MISSING_DATE:
            return "Expired"
          default:
            return "Pending"
        }
      },
    },
  })
</script>
